import { render, staticRenderFns } from "./ContentBlockButton.vue?vue&type=template&id=c7145a72"
import script from "./ContentBlockButton.vue?vue&type=script&lang=ts"
export * from "./ContentBlockButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports